
import Ticket2 from "../../../assets/duotone/Ticket2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Ticket2Icon({ className, dataTestid = "Ticket2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ticket2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
